module.exports = __webpack_public_path__ + "img/vectorCorrect.e3248292.svg";